module.exports = __webpack_public_path__ + "img/vertical_7_5_9005.275fa1ac.png";